<script>
  export let playerPos;
  export let teams;

  let canvas = document.getElementById("tactival-view");

  let socket = io("https://football.enick.ninja");
  socket.on("position_updated", function (data) {
    let ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    playerPos = JSON.parse(data);
    initCanvas(canvas);
    drawBall(ctx);
  });

  let ball;

  function drawBall(ctx) {
    //draw ball
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.arc(ball.x, ball.y, 7, 0, 2 * Math.PI);
    ctx.fill();
  }

  function drawPlayers(canvas, playerPos) {
    let ctx = canvas.getContext("2d");
    playerPos.forEach((player) => {
      if (player.name === "ball") {
        ball = { x: player.position.x, y: player.position.y };
      } else {
        ctx.beginPath();
        getTeamColor(player, ctx);
        ctx.arc(player.position.x, player.position.y, 15, 0, 2 * Math.PI);
        ctx.fill();
        // draw text
        ctx.font = "bold 14px Arial";
        getTeamContrastColor(player, ctx);
        ctx.textAlign = "center";
        ctx.fillText(player.number, player.position.x, player.position.y + 4);
      }
    });
  }

  function getTeamColor(player, ctx) {
    if (teams.guest.name === player.team) {
      ctx.fillStyle = teams.guest.color;
    } else {
      ctx.fillStyle = teams.home.color;
    }
  }

  function getTeamContrastColor(player, ctx) {
    if (teams.guest.name === player.team) {
      ctx.fillStyle = teams.guest.contrastColor;
    } else {
      ctx.fillStyle = teams.home.contrastColor;
    }
  }

  function drawPlayfield(canvas) {
    let ctx = canvas.getContext("2d");
    let img = document.getElementById("playfield-img");
    ctx.globalAlpha = 0.1;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1;
  }

  function initCanvas(canvas) {
    if (canvas != null) {
      drawPlayfield(canvas);
      drawPlayers(canvas, playerPos);
    }
  }

  $: initCanvas(canvas);
</script>

<canvas id="tactical-view" width="1050" height="680" bind:this={canvas} />
<img src="/img/playfield.svg" id="playfield-img" />

<style type="text/scss">
  canvas {
    width: 100%;
  }
  #playfield-img {
    display: none;
  }
</style>
